import { render, staticRenderFns } from "./SendEmailForBirthdaysModal.vue?vue&type=template&id=90b96bf6&scoped=true"
import script from "./SendEmailForBirthdaysModal.vue?vue&type=script&lang=js"
export * from "./SendEmailForBirthdaysModal.vue?vue&type=script&lang=js"
import style0 from "./SendEmailForBirthdaysModal.vue?vue&type=style&index=0&id=90b96bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b96bf6",
  null
  
)

export default component.exports